<template>
	<div class="background" :style="{backgroundImage: 'url(' + backgroundProp.thumbnail + ')'}">
		<img class="image" :src="overlayProp" alt="">
	</div>
</template>

<script>
	export default {
		props: ['backgroundProp', 'overlayProp'],
		data() {
			return {
			}
		},
	};
</script>

<style scoped>
	.background {
		background-size: cover;
		background-repeat: no-repeat;
		font-size: 0;
	}

	.image {
		max-width: 100%;
	}
</style>
